<template>
  <div id="liste_budgets">
    <div class="no-padding">
      <div id="zone_select">
        <label for="year">Choix de l'année&nbsp;:</label>
        <select
          id="year"
          v-model="selectedAnnee"
        >
          <option
            v-for="annee in annees"
            :key="annee"
            :value="annee"
          >
            {{ annee }}
          </option>
          <option :value="null">
            Non daté
          </option>
        </select>
        <i class="fas fa-chevron-down" />
      </div>
    </div>
    <b-row
      v-if="infoBudgets"
      class="block-budget"
    >
      <b-col cols="12">
        <Tabs>
          <Tab title="Crédit 1372">
            <Credit1372
              budget="1372"
              :annee="selectedAnnee"
              :info-budgets="infoBudgets"
              @refresh="getInfoBudgets"
            />
          </Tab>
          <Tab title="Débit 1372">
            <Debit1372
              budget="1372"
              :annee="selectedAnnee"
              :info-budgets="infoBudgets"
              @refresh="getInfoBudgets"
            />
          </Tab>
          <template v-if="selectedAnnee <= 2020">
            <Tab title="Crédit 2991">
              <Credit2991
                key="cred2991"
                budget="2991"
                :annee="selectedAnnee"
                :info-budgets="infoBudgets"
                @refresh="getInfoBudgets"
              />
            </Tab>
            <Tab title="Débit 2991">
              <Debit2991
                key="deb2991"
                budget="2991"
                :annee="selectedAnnee"
                :info-budgets="infoBudgets"
                @refresh="getInfoBudgets"
              />
            </Tab>
          </template>
          <template v-else>
            <Tab title="Crédit 1380">
              <Credit2991
                key="cred1380"
                budget="1380"
                :annee="selectedAnnee"
                :info-budgets="infoBudgets"
                @refresh="getInfoBudgets"
              />
            </Tab>
            <Tab title="Débit 1380">
              <Debit2991
                key="deb1380"
                budget="1380"
                :annee="selectedAnnee"
                :info-budgets="infoBudgets"
                @refresh="getInfoBudgets"
              />
            </Tab>
          </template>
        </Tabs>
      </b-col>
    </b-row>
    <div
      v-else
      class="zone-spinner"
    >
      <b-spinner
        class="custom-spinner"
        label="Chargement"
      />
    </div>
  </div>
</template>

<script>
import Credit1372 from "@/components/budgets/Credit1372.vue";
import Credit2991 from "@/components/budgets/Credit2991.vue";
import Debit1372 from "@/components/budgets/Debit1372.vue";
import Debit2991 from "@/components/budgets/Debit2991.vue";

import { Tabs, Tab } from "vue-slim-tabs";

import Api from "@/modules/axios";
import moment from "moment";

export default {
  name: "ListeBudgets",
  components: {
    Credit1372,
    Credit2991,
    Debit1372,
    Debit2991,
    Tabs,
    Tab,
  },
  data() {
    return {
      selectedAnnee: null,
      infoBudgets: null,
    };
  },
  computed: {
    annees() {
      const annees = [];

      for (let index = 1998; index <= new Date().getFullYear(); index += 1) {
        annees.push(index);
      }

      if (moment().isAfter(`${new Date().getFullYear()}-10-01`)) {
        annees.push(new Date().getFullYear() + 1);
      }
      return annees.reverse();
    },
  },
  watch: {
    selectedAnnee() {
      this.getInfoBudgets();
    },
  },
  mounted() {
    this.selectedAnnee = this.annees[0];
    this.getInfoBudgets();
  },
  methods: {
    /**
     * Affiche la modale d'ajout d'un budget.
     * @public
     * @param {Object} budget Infos du budgets.
     */
    openDetails(budget) {
      this.$modal.show("budget", {
        budget,
      });
    },
    /**
     * Affiche les budgets de l'années fiscale sélectionnée.
     * @public
     */
    getInfoBudgets() {
      const start = this.selectedAnnee !== null ? `${this.selectedAnnee - 1}-10-01` : "null";

      const end = this.selectedAnnee !== null ? `${this.selectedAnnee}-09-30` : "null";
      Api()
        .get(`/debit/info_budget/?start=${start}&end=${end}`)
        .then((res) => {
          this.infoBudgets = res.data;
        });
    },
  },
};
</script>

<style lang="scss">
@use "@/assets/style/_variables.scss";

#liste_budgets {
  padding: 0 1em;

  .vue-tabpanel { margin-bottom: 1rem; }

  #zone_select {
    position: relative;
    display: flex;
    align-items: center;
    label { margin-right: 0.5rem; }
    select {
      z-index: 10; // Pour que le clic soit aussi pris en compte sur le chevron
      padding: 0;
      width: 90px;
      background: none;
      color: variables.$blue-ars;
      border: none;
      border-bottom: 1px solid variables.$gray-600;
      cursor: pointer;
    }
  }
  .block-budget {
    margin-top: 1em;
    .vue-tab,
    .vue-tabpanel { border: 1px solid variables.$gray-300; }
    .vue-tabpanel { padding-top: 1em; }
  }
  .zone-spinner {
    text-align: center;
    .spinner-border {
      margin: 1rem 2rem;
      height: 50px;
      width: 50px;
    }
  }
}

// Media query

@media screen and (max-width: 1199px) {
  #liste_budgets #block_right { border: none; }
}
</style>
